import React, { Component } from "react";
import {
  apiTransactionDaily,
  apiTransactionMonthly,
  apiTransactionDetail,
} from "../../Service/api";
import "react-confirm-alert/src/react-confirm-alert.css";
import ReactTable from "react-table";
import "react-table/react-table.css";
import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  DialogContent,
} from "@mui/material";
import { Close, ImportExport, Refresh } from "@mui/icons-material";
import moment from "moment";
import ReactExport from "react-export-excel";

let timer = null;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const defaultFilterMethod = (filter, row) => {
  const cellValue = String(row[filter.id]).toLowerCase();
  return cellValue.includes(filter.value.toLowerCase());
};

const stylesDialog = {
  appBar: {
    position: "relative",
    backgroundColor: "#03101e",
  },
  title: {
    marginLeft: 0,
    flex: 1,
    fontSize: 16,
  },
};

class SummaryPage extends Component {
  constructor(props) {
    super(props);
    this.reactTable = React.createRef();
    this.state = {
      tableData: [],
      tableDisplay: [],
      filter: "",
      setOpenEdit: false,
      setOpenAddNew: false,
      openSuccess: false,
      openSuccessText: "",
      openValidation: false,
      titleValidation: "",
      titleBody: "",
      group_account_id: 0,
      group_account_name: "",
      is_available: 0,
      availableShow: [
        { id: 0, text: "Hiden" },
        { id: 1, text: "Show" },
      ],
      openAlertDelete: false,
      itemDeleted: {},
      selectAll: false,
      checked: [],
      selectRowData: [],
      openSelectedRow: false,
      openAlertDeleteAll: false,
      dataTelegramAccountShow: [],
      left: [],
      right: [],
      checked_transfer: [],
      available: [],
      showLoadingDelete: false,
      showLoadingDeleteAll: false,
      showLoadingSubmit: false,
      showLoading: false,
      dataDetail: "",
      alias: "",
      mql5Link: "",
      capital: 0,
      rateOption: [],
      rateSelected: null,
      loginInfo: "",
      total_match: 0,
      total_not_match: 0,
      selectedTab: "Daily",
      setOpenDetail: "",
      dataSummaryDetail: [],
      summaryItem: "",
    };

    this.selectedTabRef = React.createRef();
    this.selectedTabRef.current = "Daily";

    this.tableColumns = [
      {
        Header: "Account",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "account_number",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
              cursor: "pointer",
            }}
            onClick={() => this.doDetail(e.original)}
          >
            {e.original.account_number}
          </Typography>
        ),
      },

      {
        Header: "Alias",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "alias",
        style: {
          textAlign: "left",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.alias}
          </Typography>
        ),
      },

      {
        Header: "Date",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "date_close_order",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: ({ value }) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {moment(value).locale("en").format("DD MMM YYYY")}
          </Typography>
        ),
      },

      {
        Header: "Capital",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "capital",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(parseFloat(e.original.capital).toFixed(2)).toLocaleString(
                "en",
                {
                  minimumFractionDigits: 2,
                }
              )}
            </Typography>
          </>
        ),
      },
      {
        Header: "Profit",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "profit",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(parseFloat(e.original.profit).toFixed(2)).toLocaleString(
                "en",
                {
                  minimumFractionDigits: 2,
                }
              )}
            </Typography>
          </>
        ),
      },
      {
        Header: "Deposit",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "deposit",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(parseFloat(e.original.deposit).toFixed(2)).toLocaleString(
                "en",
                {
                  minimumFractionDigits: 2,
                }
              )}
            </Typography>
          </>
        ),
      },
      {
        Header: "Withdrawal",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "withdrawal",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(
                parseFloat(e.original.withdrawal).toFixed(2)
              ).toLocaleString("en", {
                minimumFractionDigits: 2,
              })}
            </Typography>
          </>
        ),
      },
      {
        Header: "Cash Flow",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "cash_flow",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(
                parseFloat(e.original.cash_flow).toFixed(2)
              ).toLocaleString("en", {
                minimumFractionDigits: 2,
              })}
            </Typography>
          </>
        ),
      },
      {
        Header: "Adjusted Capital",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "adjusted_capital",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(
                parseFloat(e.original.adjusted_capital).toFixed(2)
              ).toLocaleString("en", {
                minimumFractionDigits: 2,
              })}
            </Typography>
          </>
        ),
      },
      {
        Header: "Balance",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "original_balance",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(
                parseFloat(e.original.original_balance).toFixed(2)
              ).toLocaleString("en", {
                minimumFractionDigits: 2,
              })}
            </Typography>
          </>
        ),
      },
      {
        Header: "% Profit",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "percentage",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              {Number(
                parseFloat(e.original.percentage).toFixed(2)
              ).toLocaleString("en", {
                minimumFractionDigits: 2,
              })}
            </Typography>
          </>
        ),
      },
      {
        Header: "Remark",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "match",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
              color: e.original.match === false ? "red" : "green",
            }}
          >
            {e.original.match === true ? "Match" : "Not Match"}
          </Typography>
        ),
      },
    ];
    this.tableMonthlyColumns = [
      {
        Header: "Account",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "account_number",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
              cursor: "pointer",
            }}
            onClick={() => this.doDetail(e.original)}
          >
            {e.original.account_number}
          </Typography>
        ),
      },

      {
        Header: "Alias",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "alias",
        style: {
          textAlign: "left",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.alias}
          </Typography>
        ),
      },

      {
        Header: "Period",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "month",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.month} {e.original.year}
          </Typography>
        ),
      },

      {
        Header: "Capital",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "capital",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(parseFloat(e.original.capital).toFixed(2)).toLocaleString(
                "en",
                {
                  minimumFractionDigits: 2,
                }
              )}
            </Typography>
          </>
        ),
      },
      {
        Header: "Profit",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "profit",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(parseFloat(e.original.profit).toFixed(2)).toLocaleString(
                "en",
                {
                  minimumFractionDigits: 2,
                }
              )}
            </Typography>
          </>
        ),
      },
      {
        Header: "Deposit",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "deposit",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(parseFloat(e.original.deposit).toFixed(2)).toLocaleString(
                "en",
                {
                  minimumFractionDigits: 2,
                }
              )}
            </Typography>
          </>
        ),
      },
      {
        Header: "Withdrawal",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "withdrawal",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(
                parseFloat(e.original.withdrawal).toFixed(2)
              ).toLocaleString("en", {
                minimumFractionDigits: 2,
              })}
            </Typography>
          </>
        ),
      },
      {
        Header: "Cash Flow",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "cash_flow",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(
                parseFloat(e.original.cash_flow).toFixed(2)
              ).toLocaleString("en", {
                minimumFractionDigits: 2,
              })}
            </Typography>
          </>
        ),
      },
      {
        Header: "Adjusted Capital",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "adjusted_capital",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(
                parseFloat(e.original.adjusted_capital).toFixed(2)
              ).toLocaleString("en", {
                minimumFractionDigits: 2,
              })}
            </Typography>
          </>
        ),
      },
      {
        Header: "Balance",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "original_balance",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(
                parseFloat(e.original.original_balance).toFixed(2)
              ).toLocaleString("en", {
                minimumFractionDigits: 2,
              })}
            </Typography>
          </>
        ),
      },
      {
        Header: "% Profit",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "percentage",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              {Number(
                parseFloat(e.original.percentage).toFixed(2)
              ).toLocaleString("en", {
                minimumFractionDigits: 2,
              })}
            </Typography>
          </>
        ),
      },
      {
        Header: "Remark",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "match",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
              color: e.original.match === false ? "red" : "green",
            }}
          >
            {e.original.match === true ? "Match" : "Not Match"}
          </Typography>
        ),
      },
    ];

    this.tableColumnsDetail = [
      {
        Header: "Date",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "date_close_order",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: ({ value }) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {moment(value).locale("en").format("DD MMM YYYY")}
          </Typography>
        ),
      },

      {
        Header: "Capital",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "capital",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(parseFloat(e.original.capital).toFixed(2)).toLocaleString(
                "en",
                {
                  minimumFractionDigits: 2,
                }
              )}
            </Typography>
          </>
        ),
      },
      {
        Header: "Profit",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "profit",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(parseFloat(e.original.profit).toFixed(2)).toLocaleString(
                "en",
                {
                  minimumFractionDigits: 2,
                }
              )}
            </Typography>
          </>
        ),
      },
      {
        Header: "Deposit",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "deposit",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(parseFloat(e.original.deposit).toFixed(2)).toLocaleString(
                "en",
                {
                  minimumFractionDigits: 2,
                }
              )}
            </Typography>
          </>
        ),
      },
      {
        Header: "Withdrawal",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "withdrawal",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(
                parseFloat(e.original.withdrawal).toFixed(2)
              ).toLocaleString("en", {
                minimumFractionDigits: 2,
              })}
            </Typography>
          </>
        ),
      },

      {
        Header: "Balance",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "balance",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              $
              {Number(parseFloat(e.original.balance).toFixed(2)).toLocaleString(
                "en",
                {
                  minimumFractionDigits: 2,
                }
              )}
            </Typography>
          </>
        ),
      },
      {
        Header: "% Profit",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "percentage",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <>
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              {Number(
                parseFloat(e.original.percentage).toFixed(2)
              ).toLocaleString("en", {
                minimumFractionDigits: 2,
              })}
            </Typography>
          </>
        ),
      },
    ];
  }

  componentDidMount() {
    let loginInfo = localStorage.getItem("loginInfo");
    loginInfo = JSON.parse(loginInfo);
    // console.log(loginInfo);
    this.setState({
      loginInfo: loginInfo,
    });

    this.doLoadData();
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    clearTimeout(timer);
  }

  doLoadData = () => {
    this.props.doLoading();

    if (this.selectedTabRef.current === "Daily") {
      apiTransactionDaily()
        .then((res) => {
          this.props.doLoading();

          let data = res.data;
          if (data.status === "OK") {
            if (data.records.length > 0) {
              var temp = data.records;

              const totalMatch = temp.filter((item) => item.match === true);
              const totalNotMatch = temp.filter((item) => item.match === false);

              this.setState({
                tableData: temp,
                total_match: totalMatch.length,
                total_not_match: totalNotMatch.length,
              });
            } else {
              this.setState({ tableData: [] });
            }
          }
        })
        .catch((err) => {
          this.props.doLoading();
          console.log(err);
        });
    } else {
      apiTransactionMonthly()
        .then((res) => {
          this.props.doLoading();

          let data = res.data;
          if (data.status === "OK") {
            if (data.records.length > 0) {
              var temp = data.records;

              const totalMatch = temp.filter((item) => item.match === true);
              const totalNotMatch = temp.filter((item) => item.match === false);

              this.setState({
                tableData: temp,
                total_match: totalMatch.length,
                total_not_match: totalNotMatch.length,
              });
            } else {
              this.setState({ tableData: [] });
            }
          }
        })
        .catch((err) => {
          this.props.doLoading();
          console.log(err);
        });
    }
  };

  doLoadDetail = (account_number) => {
    this.props.doLoading();
    apiTransactionDetail({ account_number: account_number })
      .then((res) => {
        this.props.doLoading();
        const data = res.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            this.setState({
              dataSummaryDetail: data.records,
            });
          }
        }
      })
      .catch((err) => {
        this.props.doLoading();
        console.error(err);
      });
  };

  pressReset = () => {
    this.doLoadData();
  };

  handleTabChange = (tab) => {
    this.setState({
      tableData: [],
      total_match: 0,
      total_not_match: 0,
    });
    if (this.selectedTabRef.current) {
      this.selectedTabRef.current = tab;
      this.forceUpdate();
      this.doLoadData();
    }
  };

  doDetail = (item) => {
    // console.info("item: ", item);
    this.doLoadDetail(item.account_number);
    this.setState({
      setOpenDetail: true,
      summaryItem: item,
    });
  };

  handleCloseDetail = () => {
    this.setState({
      setOpenDetail: false,
      dataSummaryDetail: [],
      summaryItem: "",
    });
  };

  renderOpenDetail = () => {
    const { setOpenDetail, summaryItem } = this.state;
    const title = `Summary Account ${summaryItem.account_number}-${summaryItem.alias} `;
    return (
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={setOpenDetail}
        fullWidth={true}
        maxWidth="lg"
      >
        <AppBar style={stylesDialog.appBar}>
          <Toolbar>
            <Typography variant="h5" style={stylesDialog.title}>
              Detail Summary {summaryItem.account_number} - {summaryItem.alias}
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => this.handleCloseDetail()}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent dividers>
          <Box sx={{ flexGrow: 1 }} style={{ marginBottom: 60, marginTop: 20 }}>
            <Grid container spacing={2} mb={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <ExcelFile
                    filename={title}
                    element={
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "#4caf50",
                        }}
                        startIcon={<ImportExport />}
                      >
                        <Typography
                          variant="button"
                          style={{
                            fontSize: 14,
                            color: "#fff",
                            textTransform: "capitalize",
                          }}
                        >
                          Export Excel
                        </Typography>
                      </Button>
                    }
                  >
                    <ExcelSheet
                      data={this.state.dataSummaryDetail}
                      name={title}
                    >
                      <ExcelColumn label="Date" value="date_close_order" />
                      <ExcelColumn
                        label="Capital"
                        value={(col) =>
                          Number(
                            parseFloat(col.capital).toFixed(2)
                          ).toLocaleString("en", {
                            minimumFractionDigits: 2,
                          })
                        }
                      />
                      <ExcelColumn
                        label="Profit"
                        value={(col) =>
                          Number(
                            parseFloat(col.profit).toFixed(2)
                          ).toLocaleString("en", {
                            minimumFractionDigits: 2,
                          })
                        }
                      />
                      <ExcelColumn
                        label="Deposit"
                        value={(col) =>
                          Number(
                            parseFloat(col.deposit).toFixed(2)
                          ).toLocaleString("en", {
                            minimumFractionDigits: 2,
                          })
                        }
                      />
                      <ExcelColumn
                        label="Withdrawal"
                        value={(col) =>
                          Number(
                            parseFloat(col.withdrawal).toFixed(2)
                          ).toLocaleString("en", {
                            minimumFractionDigits: 2,
                          })
                        }
                      />
                      <ExcelColumn
                        label="Balance"
                        value={(col) =>
                          Number(
                            parseFloat(col.balance).toFixed(2)
                          ).toLocaleString("en", {
                            minimumFractionDigits: 2,
                          })
                        }
                      />
                      <ExcelColumn
                        label="% Profit"
                        value={(col) =>
                          Number(
                            parseFloat(col.percentage).toFixed(2)
                          ).toLocaleString("en", {
                            minimumFractionDigits: 2,
                          })
                        }
                      />
                    </ExcelSheet>
                  </ExcelFile>
                </div>
              </Grid>
            </Grid>

            <Grid container spacing={2} mt={2}>
              <Grid item lg={12} md={12} sm={12} xs={12} sx={12}>
                <div className="box-container">
                  <ReactTable
                    ref={(r) => (this.reactTable = r)}
                    data={this.state.dataSummaryDetail}
                    columns={this.tableColumnsDetail}
                    style={{ backgroundColor: "#f2f2f2" }}
                    filterable
                    defaultFilterMethod={defaultFilterMethod}
                    defaultPageSize={500}
                    showPageJump={false}
                    showPageSizeOptions={false}
                    showPagination={false}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>
    );
  };
  render() {
    const title =
      this.selectedTabRef.current === "Daily"
        ? "Daily Summary"
        : "Monthly Summary";
    return (
      <Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Paper
                style={{
                  borderLeft: 6,
                  borderColor: "#2f55a2",
                  color: "#FFF",
                  maxHeight: 100,
                  padding: 16,
                  paddingBottom: 24,
                }}
              >
                <Grid container spacing={1} alignItems="center">
                  <Grid
                    item
                    lg={6}
                    md={6}
                    sm={6}
                    xs={12}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Typography
                      component="span"
                      variant="h1"
                      style={{
                        fontSize: 20,
                        color: "#000",
                        fontWeight: "bold",
                        marginRight: 16,
                      }}
                    >
                      Summary
                    </Typography>
                    <Button
                      variant={
                        this.selectedTabRef.current === "Daily"
                          ? "contained"
                          : "outlined"
                      }
                      size="small"
                      style={{
                        marginRight: 8,
                        textTransform: "capitalize",
                      }}
                      onClick={() => this.handleTabChange("Daily")}
                    >
                      Daily
                    </Button>
                    <Button
                      variant={
                        this.selectedTabRef.current === "Monthly"
                          ? "contained"
                          : "outlined"
                      }
                      size="small"
                      style={{
                        textTransform: "capitalize",
                      }}
                      onClick={() => this.handleTabChange("Monthly")}
                    >
                      Monthly
                    </Button>
                  </Grid>

                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <div
                      className="contentDate"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <div style={{ marginRight: 16 }}>
                        <Typography
                          component="span"
                          variant="h1"
                          style={{
                            display: "inline",
                            color: "green",
                            fontWeight: "bold",
                            fontSize: 14,
                          }}
                        >
                          Match {this.state.total_match}
                        </Typography>
                      </div>
                      <div style={{ marginRight: 16 }}>
                        <Typography
                          component="span"
                          variant="h1"
                          style={{
                            display: "inline",
                            color: "red",
                            fontWeight: "bold",
                            fontSize: 14,
                          }}
                        >
                          Not Match {this.state.total_not_match}
                        </Typography>
                      </div>
                      <div style={{ marginRight: 16 }}>
                        <Button
                          variant="contained"
                          size="small"
                          style={{
                            backgroundColor: "#1273DE",
                            width: "100%",
                          }}
                          startIcon={<Refresh />}
                          onClick={() => this.pressReset()}
                        >
                          <Typography
                            variant="button"
                            style={{
                              color: "#fff",
                              textTransform: "capitalize",
                            }}
                          >
                            Refresh
                          </Typography>
                        </Button>
                      </div>
                      <div>
                        <ExcelFile
                          filename={title}
                          element={
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "#4caf50",
                              }}
                              startIcon={<ImportExport />}
                            >
                              <Typography
                                variant="button"
                                style={{
                                  fontSize: 14,
                                  color: "#fff",
                                  textTransform: "capitalize",
                                }}
                              >
                                Export Excel
                              </Typography>
                            </Button>
                          }
                        >
                          <ExcelSheet data={this.state.tableData} name={title}>
                            <ExcelColumn
                              label="Account"
                              value="account_number"
                            />
                            <ExcelColumn label="Alias" value="alias" />
                            {this.selectedTabRef.current === "Daily" ? (
                              <ExcelColumn
                                label="Date"
                                value={(col) =>
                                  moment(col.date_close_order)
                                    .locale("en")
                                    .format("DD MMM YYYY")
                                }
                              />
                            ) : (
                              <ExcelColumn
                                label="Period"
                                value={(col) => `${col.month} ${col.year}`}
                              />
                            )}

                            <ExcelColumn
                              label="Capital"
                              value={(col) =>
                                Number(
                                  parseFloat(col.capital).toFixed(2)
                                ).toLocaleString("en", {
                                  minimumFractionDigits: 2,
                                })
                              }
                            />
                            <ExcelColumn
                              label="Profit"
                              value={(col) =>
                                Number(
                                  parseFloat(col.profit).toFixed(2)
                                ).toLocaleString("en", {
                                  minimumFractionDigits: 2,
                                })
                              }
                            />

                            <ExcelColumn
                              label="Deposit"
                              value={(col) =>
                                Number(
                                  parseFloat(col.deposit).toFixed(2)
                                ).toLocaleString("en", {
                                  minimumFractionDigits: 2,
                                })
                              }
                            />
                            <ExcelColumn
                              label="Withdrawal"
                              value={(col) =>
                                Number(
                                  parseFloat(col.withdrawal).toFixed(2)
                                ).toLocaleString("en", {
                                  minimumFractionDigits: 2,
                                })
                              }
                            />

                            <ExcelColumn
                              label="Cash Flow"
                              value={(col) =>
                                Number(
                                  parseFloat(col.cash_flow).toFixed(2)
                                ).toLocaleString("en", {
                                  minimumFractionDigits: 2,
                                })
                              }
                            />
                            <ExcelColumn
                              label="Adjusted Capital"
                              value={(col) =>
                                Number(
                                  parseFloat(col.adjusted_capital).toFixed(2)
                                ).toLocaleString("en", {
                                  minimumFractionDigits: 2,
                                })
                              }
                            />
                            <ExcelColumn
                              label="Balance"
                              value={(col) =>
                                Number(
                                  parseFloat(col.original_balance).toFixed(2)
                                ).toLocaleString("en", {
                                  minimumFractionDigits: 2,
                                })
                              }
                            />

                            <ExcelColumn
                              label="% Profit"
                              value={(col) =>
                                Number(
                                  parseFloat(col.percentage).toFixed(2)
                                ).toLocaleString("en", {
                                  minimumFractionDigits: 2,
                                })
                              }
                            />
                            <ExcelColumn
                              label="Remark"
                              value={(col) =>
                                col.match ? "Match" : "Not Match"
                              }
                            />
                          </ExcelSheet>
                        </ExcelFile>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className="box-container">
          <ReactTable
            ref={(r) => (this.reactTable = r)}
            data={this.state.tableData}
            columns={
              this.selectedTabRef.current === "Daily"
                ? this.tableColumns
                : this.tableMonthlyColumns
            }
            style={{ backgroundColor: "#f2f2f2" }}
            filterable
            defaultFilterMethod={defaultFilterMethod}
            defaultPageSize={500}
            showPageJump={false}
            showPageSizeOptions={false}
            showPagination={false}
          />
        </div>
        {this.renderOpenDetail()}
      </Box>
    );
  }
}
export default SummaryPage;
